import IUserList from '../UserList/UserList.interface';
import IOrganizationUser from './OrganizationUser.interface';

// Helper class to store all the Organization User data from db to an array
export const adminUserList = (arrAdmin: Array<IOrganizationUser | null>): Array<IUserList> => {
  // Declaring the array as of type IUserList or null
  const arrUserList: Array<IUserList> = [];
  // Mapping the data from db to the array of type IOrganizationUser or null
  arrAdmin.forEach((element: IOrganizationUser | null, index) => {
    if (element) {
      arrUserList.push({
        key: index.toString(),
        name: `${element.name}`,
        email: element.email ?? '',
        level: null,
        progress: null,
        icon: undefined,
        module: null,
        status: null,
        role: element.role,
        moduleList: element.moduleList,
        phone: `${element.phone}`,
        companyName: `${element.orgName}`,
        orgEmail: `${element.orgEmail}`,
        buttonStatus: null,
        isLocked: element.isLocked,
        isActive: element.isActive
      });
    }
  });
  return arrUserList;
};
